import { VideoThumbnail } from './VideoThumbnail';
import { PromoteGroupedIcon } from '../PromoteGroupedIcon';
import PromoteIcon from '../PromoteIcon';
import RecommendationIcon from '../RecommendationIcon';
import { ContentType, TaskActionData, TaskData } from '../types';

export type LeadingProps = Readonly<{
  isVideo: boolean;
  data: TaskData & TaskActionData;
  contentType: ContentType;
  onAction: (data: TaskData & TaskActionData) => void;
}>;

export function Leading({
  isVideo,
  data,
  contentType,
  onAction,
}: LeadingProps): JSX.Element | null {
  if (isVideo && data.thumbnail) {
    return (
      <VideoThumbnail
        src={data.thumbnail}
        alt="Video thumbnail"
        onClick={() => onAction(data)}
      />
    );
  }

  if (contentType === 'promote') return <PromoteIcon type={data.iconType} />;
  if (contentType === 'recommendation')
    return <RecommendationIcon type={data.iconType} />;
  if (contentType === 'promoteGrouped')
    return <PromoteGroupedIcon type={data.id} />;
  return null;
}
